export default {
  INFOEMATION: [
    {
      id: 72,
      title: '​腾讯云xDeepSeek：率先上线最新版V3模型API接口、大模型知识引擎内置新模型服务',
      content: '3月25日晚，腾讯云率先上线DeepSeek-V3-0324版本，企业和开发者可以通过腾讯云直接调用新版模型的API接口，获得稳定优质的服务。同时，腾讯云旗下大模型知识引擎也接入了新版模型，通过平台内置的RAG和工作流能力，用户可以快速搭建专属AI应用。...',
      date: '2025年3月26日',
      year: 2025,
      month: 3,
      url: 'OPEN_NEWS_72',
      img: require('../img/newscenter/news72.webp')
    },
    {
      id: 71,
      title: '腾讯2024年财报：To B营收2120亿元创新高，元宝日活增长超20倍',
      content: '刚刚，腾讯发布2024年Q4及全年度财报...',
      date: '2025年3月20日',
      year: 2025,
      month: 3,
      url: 'OPEN_NEWS_71',
      img: require('../img/newscenter/news71.gif')
    },
    {
      id: 70,
      title: '腾讯云智能数智人、企点客服全面接入DeepSeek！',
      content: '2月24日，腾讯云智能数智人、腾讯企点客服宣布接入DeepSeek大模型。借助DeepSeek大模型优秀的语义理解和意图识别能力，数智人进一步优化交互、播报等场景的用户体验，企点客服则实现了问答质量和客户满意度的双重提升。...',
      date: '2025年2月25日',
      year: 2025,
      month: 2,
      url: 'OPEN_NEWS_70',
      img: require('../img/newscenter/news70.webp')
    },
    {
      id: 69,
      title: '腾讯云：率先支持DeepSeek全系模型精调与推理',
      content: '近日，腾讯云旗下TI平台宣布支持DeepSeek「全系模型」的企业级精调与推理，帮助开发者更好解决「数据预处理难」、「模型训练门槛高」、「在线部署及运维复杂」等问题。...',
      date: '2025年2月21日',
      year: 2025,
      month: 2,
      url: 'OPEN_NEWS_69',
      img: require('../img/newscenter/news69.webp')
    },
    {
      id: 68,
      title: '腾讯云X DeepSeek：API调用+联网搜索，分钟打造企业级 AI 应用',
      content: '刚刚，腾讯云再放大招——不仅上线了DeepSeek-R1和V3原版模型的API接口，还将它们接入了大模型知识引擎，并支持联网搜索，成为国内率先实现这一能力的云厂商。现在只需拖拽几步，就能搭建一个基于DeepSeek、集「智能问答+知识管理+实时搜索」...',
      date: '2025年2月8日',
      year: 2025,
      month: 2,
      url: 'OPEN_NEWS_68',
      img: require('../img/newscenter/news68.webp')
    },
    {
      id: 53,
      title: '业界最大！腾讯优图发布Real-IAD大规模工业异常检测数据集！',
      content: '为什么构建Large-scale Real-world Real-IAD数据集？一方面，大多数最先进的方法在MVTec / VisA等主流数据集上已经达到饱和(AUROC超过99%)，无法很好地区分方法之间的差异，且由于难度较小而与实际应用场景之间存在较大差距...',
      date: '2024年10月29日',
      year: 2024,
      month: 10,
      url: 'OPEN_NEWS_53',
      img: require('../img/newscenter/news53.png')
    },
    {
      id: 52,
      title: '腾讯与小米击了个掌！',
      content: '挥挥手，欢迎回家。最近，鹅的好伙伴小米发布新款智能门锁M30 Pro，正在让手掌成为钥匙。在这背后，正是鹅厂的黑科技——“刷掌技术”。基于腾讯优图实验室自研的“掌纹+掌静脉”AI能力，鹅厂的刷掌技术经过了海量实际应用测试，实力那叫一个硬。',
      date: '2024年9月25日',
      year: 2024,
      month: 9,
      url: 'OPEN_NEWS_52',
      img: require('../img/newscenter/news52.gif')
    },
    {
      id: 51,
      title: '大模型普惠时代，行业热议落地路径',
      content: '2024年是大模型应用落地元年。随着场景落地不断深化，大模型要贴近场景创造价值已经是业界的共识。9月5日，2024腾讯全球数字生态大会云上智能峰会在深圳举行。在峰会上，腾讯云邀请来迈瑞医疗、工业富联、易车、同程旅行、中信百信银行等多个来自各个行业的嘉宾...',
      date: '2024年9月6日',
      year: 2024,
      month: 9,
      url: 'OPEN_NEWS_51',
      img: require('../img/newscenter/news51.png')
    },
    {
      id: 50,
      title: '腾讯云副总裁吴运声：面向场景创造价值才是大模型发展的意义',
      content: '9月5日，在2024腾讯全球数字生态大会云上智能峰会上，腾讯云副总裁、腾讯云智能负责人、优图实验室负责人吴运声分享了腾讯云在智能领域的最新进展，并探讨了大模型在产业中的应用和未来发展。吴运声在演讲中指出，大模型的发展呈现出两个明显趋势：模型性能不断提升和落地场景不断丰富。',
      date: '2024年9月6日',
      year: 2024,
      month: 9,
      url: 'OPEN_NEWS_50',
      img: require('../img/newscenter/news50.png')
    },
    {
      id: 49,
      title: '对标GPT-4o，腾讯混元再升级，大模型加速落地！',
      content: '大模型落地持续加速中。9月5日，腾讯宣布推出新一代大模型“混元Turbo”，相比前代模型，腾讯混元Turbo性能显著提升，训练效率提升108%，推理效率提升 100%，推理成本降低 50%，效果在多个基准测试上对标GPT-4o，且第三方测评居国内第一。',
      date: '2024年9月5日',
      year: 2024,
      month: 9,
      url: 'OPEN_NEWS_49',
      img: require('../img/newscenter/news49.png')
    },
    {
      id: 48,
      title: '三年覆盖逾百万适龄女性！腾讯优图以AI助力宫颈癌高效防控',
      content: '宫颈癌是目前唯一病因明确、早期可预防和治疗、潜在消除的癌症。早期诊断与治疗对于宫颈癌的预防和治愈至关重要。然而，据2022年国家癌症中心报告显示，2022年我国新发宫颈癌病例约有11.93万例，死亡人数约为3.72万人。',
      date: '2023年12月5日',
      year: 2023,
      month: 12,
      url: 'OPEN_NEWS_48',
      img: require('../img/newscenter/news48.png')
    },
    {
      id: 47,
      title: '20年20人20问丨腾讯杰出科学家郑冶枫：AI让所有人回到同一起跑线',
      content: '腾讯新闻20周年特别策划《20年20人20问》持续更新！携手全球顶级思想家、企业家、教授学者、体育冠军、作家、名人作为“未来提问官”，一起向未来发问，共同探讨未来20年的未知世界，畅想上天入地的潜在可能。',
      date: '2023年11月25日',
      year: 2023,
      month: 11,
      url: 'OPEN_NEWS_47',
      img: require('../img/newscenter/news47.jpeg')
    },
    {
      id: 42,
      title: '登陆广东！刷掌支付规模化落地实现新突破',
      content: '在持续的技术创新及大规模应用实践下，微信刷掌支付落地再获新进展。自9月5日开始，深圳海岸城内所有街电大屏充电宝设备正式上线"微信刷掌租借"服务，标志着全国首家购物中心成功落地微信刷掌支付...',
      date: '2023年9月11日',
      year: 2023,
      month: 7,
      url: 'OPEN_NEWS_42',
      img: require('../img/newscenter/news42.png')
    },
    {
      id: 39,
      title: 'GitHub斩获3K星！腾讯优图推动多模态大语言模型的创新研究',
      content: '近日，腾讯优图实验室与中国科学技术大学携手，共同发表了一篇名为《A Survey on Multimodal Large Language Models》的学术论文。该文对多模态大语言模型（MLLM）进行了全面总...',
      date: '2023年7月14日',
      year: 2023,
      month: 7,
      url: 'OPEN_NEWS_39',
      img: require('../img/newscenter/news39.png')
    },
    {
      id: 36,
      title: '腾讯优图荣获CVPR 2023视觉异常检测挑战赛冠军！',
      content: '近日，腾讯优图实验室在CVPR 2023（IEEE国际计算机视觉与模式识别会议）中斩获了视觉异常检测（Visual Anomaly and Novelty Detection，VAND）挑战赛的冠军，这一荣誉标志着...',
      date: '2023年6月14日',
      year: 2023,
      month: 6,
      url: 'OPEN_NEWS_36',
      img: require('../img/newscenter/news36.png')
    },
    {
      id: 28,
      title: '腾讯牵手安阳，人机协同助力甲骨文“破译”与传承活化',
      content: '在中国考古学界流传一句话，“没有哪处遗址的重要性超过殷墟',
      date: '2022年12月10日',
      year: 2022,
      month: 12,
      url: 'OPEN_NEWS_28',
      img: require('../img/newscenter/news28.jpeg')
    },
    {
      id: 26,
      title: '喜报！腾讯优图荣获维科杯·OFweek 2022人工智能行业社会责任贡献奖',
      content: '11月16日，维科杯·OFweek 2022物联网与人工智能行业年度评选（OFweek China IoT＆AI Awards 2022）颁奖典礼成功举办，腾讯优图实验室凭借在人工智能领域取得令人瞩目的...',
      date: '2022年11月18日',
      year: 2022,
      month: 11,
      url: 'OPEN_NEWS_26',
      img: require('../img/newscenter/news26.jpeg')
    },
    {
      id: 25,
      title: '腾讯优图斩获首届人工智能安全大赛-深度伪造安全竞赛冠军',
      content: '随着深度合成技术的不断发展，Deepfakes等技术可以轻易地对人脸的面部区域进行篡改，并且伪造的人脸越来越逼真，有些甚至达到人眼也难以区分真假的地步。这些技术在娱乐场景得...',
      date: '2022年9月23日',
      year: 2022,
      month: 9,
      url: 'OPEN_NEWS_25',
      img: require('../img/newscenter/news25.png')
    },
    {
      id: 22,
      title: '2022世界人工智能大会，腾讯云+AI驱动技术创新与场景创新双向融合',
      content: '9月3日，2022世界人工智能大会·腾讯论坛在上海举办，聚焦“人工智能技术助力数字经济高质量发展”，腾讯展示了AI平台建设、产业应用、行业研究的最新成果。与此同时，腾讯联合国...',
      date: '2022年9月3日',
      year: 2022,
      month: 9,
      url: 'OPEN_NEWS_22',
      img: require('../img/newscenter/news22.jpeg')
    },
    {
      id: 23,
      title: '腾讯发布国内首份金融AI白皮书，聚焦金融行业数字化升级',
      content: '9月3日，2022世界人工智能大会腾讯论坛上，腾讯发布国内首份金融AI白皮书——《价值共生·2022金融AI发展研究报告》（以下简称“报告”）。报告由北京金融科技产业联盟作为指导单...',
      date: '2022年9月3日',
      year: 2022,
      month: 9,
      url: 'OPEN_NEWS_23',
      img: require('../img/newscenter/news23.jpeg')
    },
    {
      id: 21,
      title: '2022世界人工智能大会最高奖项公布，腾讯「探星计划」荣获SAIL之星',
      content: '9月1日，2022世界人工智能大会（WAIC）在上海正式开幕。在开幕式上，2022世界人工智能大会最高奖项“SAIL奖”也正式官宣。经过初评、复评、终评等多轮角逐，最终从800多个全球...',
      date: '2022年9月1日',
      year: 2022,
      month: 9,
      url: 'OPEN_NEWS_21',
      img: require('../img/newscenter/news21.jpeg')
    },
    {
      id: 19,
      title: '论坛预告 | 9月3日，腾讯WAIC论坛与你瞰见未来',
      content: '一年一度的世界人工智能大会（WAIC）如期而至，每年我们都在这场AI的盛会中讨论技术对社会、对生活的深刻影响。去年WAIC腾讯论坛以“你即为光”为主题，致敬每一次为科技进步所提...',
      date: '2022年8月20日',
      year: 2022,
      month: 8,
      url: 'OPEN_NEWS_19',
      img: require('../img/newscenter/news19.png')
    },
    {
      id: 17,
      title: 'ACM MM 2022 | 腾讯优图11篇论文入选，含盲超分辨率算法、视频场景分割分类等研究方向',
      content: '近日，腾讯优图实验室11篇论文被国际人工智能多媒体领域顶级会议ACM MM 2022（ACM International Conference on Multimedia）所接收，涵盖盲超分辨率算法、视频场景分割分类...',
      date: '2022年7月7日',
      year: 2022,
      month: 7,
      url: 'OPEN_NEWS_17',
      img: require('../img/newscenter/news17.png')
    },
    {
      id: 16,
      title: '腾讯优图斩获CVPR 2022 CLEAR Challenge持续学习重磅比赛第一名',
      content: '近日，在 CVPR 2022 举办的CLEAR Challenge比赛中，腾讯优图实验室在CLEAR10和CLEAR100数据集赛道均取得了第一名的成绩...',
      date: '2022年6月24日',
      year: 2022,
      month: 6,
      url: 'OPEN_NEWS_16',
      img: require('../img/newscenter/news16.png')
    },
    {
      id: 15,
      title: '第二届腾讯Light·公益创新挑战赛决赛收官，24支队伍用AI创造可持续发展新路径',
      content: 'AI、云计算为代表的数字技术，近年来已逐步成为驱动实体产业和数字经济高质量发展的重要引擎。与此同时，以腾讯为代表的互联网科技公司也在不断探索将数字技术应用于...',
      date: '2022年6月27日',
      year: 2022,
      month: 6,
      url: 'OPEN_NEWS_15',
      img: require('../img/newscenter/news15.jpg')
    },
    {
      id: 14,
      title: '全球第二！腾讯视觉AI再突破',
      content: '近日，国际权威研究机构Gartner发布2022年度《Magic Quadrant for Cloud AI Developer Services》研究报告...',
      date: '2022年6月6日',
      year: 2022,
      month: 6,
      url: 'OPEN_NEWS_14',
      img: require('../img/newscenter/news16.jpg')
    },
    {
      id: 13,
      title: '斩获2022数博会领先科技成果奖，腾讯优图人脸安全能力再获权威认证',
      content: '5月26日，2022中国国际大数据产业博览会(以下简称“数博会”）在线上举办。其中，“数博发布之领先科技成果”奖于数博会开幕当天正式揭晓，经过激烈角逐和层层选拔...',
      date: '2022年5月26日',
      year: 2022,
      month: 5,
      url: 'OPEN_NEWS_13',
      img: require('../img/newscenter/news13.jpg')
    },
    {
      id: 10,
      title: 'CVPR 2022丨无监督预训练下的视频场景分割',
      content: '对于视频场景分割任务，如何更好地在无标注长视频上进行自监督预训练？如何运用视频特征对该任务进行建模？腾讯优图实验室、深圳大学、KAUST等机构的研究成果入选今年CVPR 2022会议...',
      date: '2022年5月19日',
      year: 2022,
      month: 5,
      url: 'OPEN_NEWS_10',
      img: require('../img/newscenter/news10.jpg')
    },
    {
      id: 9,
      title: 'IJCAI 2022 放榜，腾讯优图实验室三篇论文入选',
      content: '近日，AI顶级学术会议IJCAI 2022(人工智能国际联合会议，International Joint Conference on Artificial Intelligence)发布了论文录用结果。腾讯优图实验室共有三篇论文入选，内容涵盖语义分割、人脸伪造视频检测、神经头像合成等研究领域...',
      date: '2022年5月5日',
      year: 2022,
      month: 5,
      url: 'OPEN_NEWS_9',
      img: require('../img/newscenter/news9.jpg')
    },
    {
      id: 1,
      title: '腾讯优图亮相AI Expo Korea，展示最新AI产品技术',
      content: '4月13日-15日，腾讯优图实验室参加了韩国首尔人工智能展会（AI Expo Korea），携AI换脸技术、视频超分、AI广告植入、视频智能标签4款AI产品亮相...',
      date: '2022年4月14日',
      year: 2022,
      month: 4,
      url: 'OPEN_NEWS_1',
      img: require('../img/newscenter/news1.jpg')
    },
    {
      id: 2,
      title: 'CVPR 2022 | 腾讯优图实验室30篇论文入选，含场景文本语义识别、3D人脸重建、目标检测、视频场景分割和视频插帧等领域 ',
      content: '近日，CVPR 2022官方公布了接收论文列表，来自腾讯优图实验室共计30篇论文被CVPR收录，论文涵盖包括场景文本语义识别、3D人脸重建、人体姿态估计 (HPE)、目标检测、图像风格转换、视频场景分割和视频插帧等研究领域...',
      date: '2022年3月14日',
      year: 2022,
      month: 3,
      url: 'OPEN_NEWS_2',
      img: require('../img/newscenter/news2.jpg')
    },
    {
      id: 4,
      title: '获评2021人工智能 “创新之星”！腾讯优图人脸安全能力获权威认可',
      content: '为推动和引领人工智能领域创新发展，近日中国人工智能产业发展联盟、厦门人工智能安全研究院组织开展了2021人工智能“创新之星”、“创新人物”评选工作...',
      date: '2022年2月23日',
      year: 2022,
      month: 2,
      url: 'OPEN_NEWS_4',
      img: require('../img/newscenter/news4.jpg')
    }
  ],
  ACTIVITY: [
    {
      id: 77,
      title: '火热报名中| 第五届Light创造营邀你一起破茧成光！',
      content: '当三月的海风漫过鼓浪屿琴键 日光岩下的木棉染红了沙坡尾的黄昏 在三角梅攀上红砖骑楼的季节 又是一年Light创造营 如春芽破土...',
      date: '2025年3月6日',
      year: 2025,
      month: 3,
      url: 'OPEN_NEWS_77',
      img: require('../img/newscenter/news77.webp')
    },
    {
      id: 76,
      title: '第五届Light创造营启动！提供全方位技术支持，助力公益可持续创新',
      content: '3月3日，第五届Light创造营在厦门正式拉开帷幕。本届Light号召高校学子利用AI技术打造多元技术公益解决方案，共同应对社会公共议题，持续释放技术公益的内在价值。...',
      date: '2025年3月3日',
      year: 2025,
      month: 3,
      url: 'OPEN_NEWS_76',
      img: require('../img/newscenter/news76.webp')
    },
    {
      id: 75,
      title: '科创教育有几种解法？这场新年大会探索“科学+”的无限可能！',
      content: '2024年12月31日晚，由上海市科委、上海市教委指导，上海科技馆、腾讯公益慈善基金会主办的“科际穿越·科创校长空间站”科学新年大会暨腾讯科技之夜在上海自然博物馆（上海科技馆分馆）举办。...',
      date: '2025年1月8日',
      year: 2025,
      month: 1,
      url: 'OPEN_NEWS_75',
      img: require('../img/newscenter/news75.webp')
    },
    {
      id: 74,
      title: '春蕾绽放 科技筑梦 ——记2024年春蕾科技女孩项目上海研学营活动',
      content: '2024年12月29日至2025年1月1日，中国儿童少年基金会联合腾讯公益慈善基金会，邀请四川省攀枝花市米易县六所初中30名春蕾女孩来到上海，利用四天时间穿梭五大地标，完成了一场探索之旅、科技之旅、成长之旅。...',
      date: '2025年1月7日',
      year: 2025,
      month: 1,
      url: 'OPEN_NEWS_74',
      img: require('../img/newscenter/news74.webp')
    },
    {
      id: 73,
      title: '「第四届Light技术公益创造营」获评 2024 中国最受开发者欢迎的技术活动',
      content: '1 月 6 日，中国技术先锋年度评选丨2024 中国最受开发者欢迎的技术活动榜单正式发布。Light 技术公益创造营作为国内最具影响力的技术公益平台之一，成功入选该榜单。...',
      date: '2025年1月6日',
      year: 2025,
      month: 1,
      url: 'OPEN_NEWS_73',
      img: require('../img/newscenter/news73.webp')
    },
    {
      id: 58,
      title: '1024特辑 | 我们采访了一群程序员，他们说',
      content: '据说，世上只有两种人，一种是懂二进制的，一种是不懂二进制的，可以说二进制计数的基本计量单位是程序员最熟悉的数字...',
      date: '2024年10月24日',
      year: 2024,
      month: 10,
      url: 'OPEN_NEWS_58',
      img: require('../img/newscenter/news58.png')
    },
    {
      id: 57,
      title: 'PRCV2024大会正式召开，腾讯优图携前沿科技成果亮相现场',
      content: '10月18日-20日，由中国自动化学会（CAA）、中国图象图形学学会（CSIG）、中国人工智能学会（CAAI）和中国计算机学会（CCF）联合主办，新疆大学承办的第七届中国模式识别与计算机视觉大会（PRCV 2024）在乌鲁木齐举办。',
      date: '2024年10月21日',
      year: 2024,
      month: 10,
      url: 'OPEN_NEWS_57',
      img: require('../img/newscenter/news57.png')
    },
    {
      id: 56,
      title: '全球数字贸易博览会丨腾讯优图亮相第三届数贸会，速来体验！',
      content: '9月25日-29日，全球顶尖科技汇聚的第三届全球数字贸易博览会（简称数贸会）在杭州大会展中心正式举办啦。今年的数贸会在往届基础上加码升级，综合展示展区、丝路电商展区、数据与金融展区、人工智能展区、智慧城市展区、数字文娱展区、数智出行展区、数字医疗展区、消费电子展区等9个展区竞相亮相...',
      date: '2024年9月26日',
      year: 2024,
      month: 9,
      url: 'OPEN_NEWS_56',
      img: require('../img/newscenter/news56.png')
    },
    {
      id: 55,
      title: '2024服贸会 | 腾讯优图吴贤：大型语言模型在医疗临床决策中的创新应用',
      content: '9月12日至16日，2024年中国国际服务贸易交易会在北京举办。本届服贸会主题为“全球服务，互惠共享”，由商务部和北京市人民政府共同主办，着力打造扩大开放、深化合作、引领创新的重要平台。',
      date: '2024年9月14日',
      year: 2024,
      month: 9,
      url: 'OPEN_NEWS_55',
      img: require('../img/newscenter/news55.png')
    },
    {
      id: 54,
      title: '1079支队伍齐聚、聚焦三大社会议题，第四届Light技术公益创造营圆满收官',
      content: '7月19日，第四届Light·技术公益创造营总决选在上海圆满收官。历经近5个月的专业选拔和评审后，20支队伍从1079个项目中脱颖而出，开展了精彩的路演环节，中国传媒大学动画与数字艺术学院智能媒体设计实验室队、芒种队成功摘得最受瞩目的“公益创新项目”。Light平台不仅...',
      date: '2024年7月22日',
      year: 2024,
      month: 7,
      url: 'OPEN_NEWS_54',
      img: require('../img/newscenter/news54.png')
    },
    {
      id: 46,
      title: '以数字技术助力文物“焕新”，腾讯首次亮相进博会中国馆',
      content: '在进博会现场“爬长城”“修文物”，和人工智能来一场电竞比赛，会是怎样的体验？在11月5日开幕的第六届中国国际进口博览会上，腾讯携多款科技与文化产品应用如期而至。其中在中国馆内，多个“文物焕新”项目将活化后的中国文明展现在全世界面前；而在人工...',
      date: '2023年11月8日',
      year: 2023,
      month: 11,
      url: 'OPEN_NEWS_46',
      img: require('../img/newscenter/news46.jpeg')
    },
    {
      id: 45,
      title: '腾讯优图携AI照相馆亮相2023 ADM，探索AI与艺术结合可能性',
      content: '11月2日，第二届全球数字贸易博览会·数字消费周暨2023ADM在ADM MORE（武林之星博览中心1号厂房）开幕。作为此次数字消费周的核心活动内容，ADM为大众提供了美好生活方式多种可能性，为产业带来设计的联结价值，同时也一直在积极探索并实践...',
      date: '202311月7日',
      year: 2023,
      month: 11,
      url: 'OPEN_NEWS_45',
      img: require('../img/newscenter/news45.png')
    },
    {
      id: 37,
      title: '2023WAIC：腾讯云MaaS再升级，AI for Science新突破',
      content: '7月7日，2023世界人工智能大会·腾讯论坛在上海世博中心举办。论坛以“无限可能”为主题，腾讯公布了一系列AI创新进展。...',
      date: '2023年7月7日',
      year: 2023,
      month: 7,
      url: 'OPEN_NEWS_37',
      img: require('../img/newscenter/news37.jpeg')
    },
    {
      id: 34,
      title: '近1500支队伍、6000名开发者齐聚，第三届Light技术公益创造营收官',
      content: '在很多老年人看来，融入数字生活并不容易，经常误点广告、不时接到诈骗电话、不会操作智能手机……但有些老年人并不担心这些，“误点了付款，有人会打电话过来，提醒我不要被骗了。”一位老人放心地进行着“网上冲浪”。而这，是源于Light·技术公益...',
      date: '2023年5月15日',
      year: 2023,
      month: 5,
      url: 'OPEN_NEWS_34',
      img: require('../img/newscenter/news34.png')
    },
    {
      id: 29,
      title: '第三届Light·技术公益创造营正式启动：聚焦三大议题，探索技术公益可持续路径',
      content: '2月2日，全面升级的第三届Light·技术公益创造营在海南海口正式启动，围绕数字时代下“未成年人心理健康”、“老年人用网安全”、“生物多样性保护”三大议题，号召社会各界人士打造技术公益多元解决方案，以共同解决更多的社会公共议题，持续释放...',
      date: '2023年2月3日',
      year: 2023,
      month: 2,
      url: 'OPEN_NEWS_29',
      img: require('../img/newscenter/news29.jpeg')
    },
    {
      id: 8,
      title: '报名开启 | “智变未来”腾讯产业数字化转型论坛，邀你共同参与',
      content: '3月18日，由上海经济和信息化委指导，腾讯华东总部和腾讯优图实验室联合主办，腾讯企点、腾讯WeTest、腾讯云AI、腾讯研究院、上海智慧城市发展研究院联合支持的2022年首场“智变未来”腾讯产业数字化转型论坛即将在上海市西岸美术馆报告厅举办...',
      date: '2022年3月3日',
      year: 2022,
      month: 3,
      url: 'OPEN_NEWS_8',
      img: require('../img/newscenter/news8.jpg')
    },
    {
      id: 5,
      title: '第二届腾讯Light·公益创新挑战赛启动，三大赛题聚焦可持续发展社会价值',
      content: '12月23日，“创变者”2021年度腾讯Light论坛在厦门正式举办。在论坛上，由全国妇联宣传部指导，腾讯公司联合中国儿童中心主办，企鹅伴成长、腾讯华东总部、腾讯SSV创新办学实验室、企鹅爱地球、腾讯优图实验室、腾讯云AI、腾讯云微搭承办...',
      date: '2021年12月24日',
      year: 2021,
      month: 12,
      url: 'OPEN_NEWS_5',
      img: require('../img/newscenter/news5.jpg')
    }
  ],
  TECHNOLOGY: [
    {
      id: 82,
      title: 'CVPR 2025｜腾讯优图实验室22篇论文入选，含深度伪造检测、自回归视觉生成、多模态大语言模型等研究方向',
      content: '近日， CVPR 2025（IEEE/CVF Conferenceon on Computer Vision and Pattern Recognition）论文录用结果揭晓，本次大会共2878篇被录用，录用率为22.1%。CVPR是计算机视觉领域的顶级国际会议，CCF A类会议...',
      date: '2025年3月19日',
      year: 2025,
      month: 3,
      url: 'OPEN_NEWS_82',
      img: require('../img/newscenter/news82.webp')
    },
    {
      id: 81,
      title: 'ICLR 2025｜腾讯优图实验室6篇论文入选，含多模态大语言模型、人脸识别等研究方向',
      content: '近日，第 13 届 ICLR（International Conference on Learning Representations）国际学习表征会议公布了论文录用结果。本次大会共收到 11,565 篇有效论文投稿，录用率为 32.08%。...',
      date: '2025年3月12日',
      year: 2025,
      month: 3,
      url: 'OPEN_NEWS_81',
      img: require('../img/newscenter/news81.webp')
    },
    {
      id: 80,
      title: 'ICASSP 2025｜腾讯优图实验室4篇论文入选，含语音识别、语音合成等研究方向',
      content: '近期，ICASSP（International Conference on Acoustics, Speech, and Signal Processing） 2025会议公布了论文录用结果。ICASSP是IEEE信号处理学会（Signal Processing Society）的学术年会，是全世界规模最大...',
      date: '2025年3月1日',
      year: 2025,
      month: 3,
      url: 'OPEN_NEWS_80',
      img: require('../img/newscenter/news80.webp')
    },
    {
      id: 79,
      title: 'LLM界的AlphaGo：DeepSeek R1范式复现笔记来了！',
      content: '不久前，有人在GitHub上公开了Logic RL项目，完整开源了从base 模型到R1 的全流程代码，让每个人都能复现这个号称"LLM界AlphaGo"的神奇模型，各大开源社区引发了一波又一波的复现狂潮。...',
      date: '2025年2月20日',
      year: 2025,
      month: 2,
      url: 'OPEN_NEWS_79',
      img: require('../img/newscenter/news79.webp')
    },
    {
      id: 78,
      title: '必看！万字长文为你深度解析DeepSeek',
      content: '2025开年，AI黑马DeepSeek可谓搅翻全球，让同行们都惊到了。...',
      date: '2025年2月10日',
      year: 2025,
      month: 2,
      url: 'OPEN_NEWS_78',
      img: require('../img/newscenter/news78.webp')
    },
    {
      id: 63,
      title: 'NeurIPS 2024｜腾讯优图实验室10篇论文入选，含持续学习、大型语言模型、深度伪造检测等研究方向',
      content: '近期，第38届神经信息处理系统大会（NeurIPS 2024）公布了录取结果。会议共收到了15671篇有效论文投稿，共有超四千篇收录，录取率为25.8%。NeurIPS是CCF推荐的A类国际学术会议，在人工智能及计算机理论领域享有较高学术声誉...',
      date: '2024年10月14日',
      year: 2024,
      month: 10,
      url: 'OPEN_NEWS_63',
      img: require('../img/newscenter/news63.png')
    },
    {
      id: 62,
      title: '利用公开知识定向提升大模型，腾讯优图联合上海交通大学提出新型开源增强知识框架',
      content: '近年来，LLMs 在众多任务和领域取得了显著发展，但为了在实际业务场景发挥模型的专业能力，通常需要在领域特定或任务特定的数据上进行指令微调。传统的指令微调往往需要大量的有标注数据和计算资源，对于实际业务场景来说是很难获取的...',
      date: '2024年10月10日',
      year: 2024,
      month: 10,
      url: 'OPEN_NEWS_62',
      img: require('../img/newscenter/news62.png')
    },
    {
      id: 61,
      title: 'ACM MM 2024｜腾讯优图实验室10篇论文入选，含跨模态融合、多模态大语言模型、扩散变换器、域泛化语义分割等研究方向',
      content: '近期，第32届ACM国际多媒体大会（Proceedings of the 32nd ACM International Conference on Multimedia，ACM MM 2024）公布了论文录用结果，会议共收到4385篇投稿，共录用1149篇论文，录用率约为26.2%...',
      date: '2024年9月20日',
      year: 2024,
      month: 9,
      url: 'OPEN_NEWS_61',
      img: require('../img/newscenter/news61.png')
    },
    {
      id: 60,
      title: 'INTERSPEECH 2024｜腾讯优图发布语音识别领域研究新进展',
      content: 'Interspeech 是由国际语音通讯协会(International Speech Communicaation Association,ISCA)创办的语音处理领域旗舰国际会议，会议旨在展示最新的研究成果，挖掘语音应用的新机遇，推动语音科技的发展。作为全球最大的...',
      date: '2024年9月12日',
      year: 2024,
      month: 9,
      url: 'OPEN_NEWS_60',
      img: require('../img/newscenter/news60.png')
    },
    {
      id: 59,
      title: '业界最全！腾讯优图联合上海交通大学推出大模型指令微调数据集评测体系',
      content: '想快速迭代垂直细分领域小模型，数据不够怎么办？开源数据似大海，怎么找到高质量的SFT数据？训练资源吃紧，来不及遍历百千万级的SFT数据，如何靠采样实现「四两拨千斤」？',
      date: '2024年8月27日',
      year: 2024,
      month: 8,
      url: 'OPEN_NEWS_59',
      img: require('../img/newscenter/news59.png')
    },
    {
      id: 44,
      title: '优tech分享｜强化人脸安全，腾讯优图提出深度伪造溯源新基准',
      content: 'AIGC技术的快速发展使得现实场景出现了大量新型的伪造图像，引发了公众对AI内容安全的担忧。为应对这些挑战，腾讯优图实验室构建了一个“开放场景下深度伪造溯源”（OpenWorld-DeepFake...',
      date: '2023年10月20日',
      year: 2023,
      month: 10,
      url: 'OPEN_NEWS_44',
      img: require('../img/newscenter/news44.png')
    },
    {
      id: 43,
      title: 'NeurIPS 2023 | 腾讯优图实验室7篇论文入选，含多模态查询、互联网图像监督学习等研究方向',
      content: 'NeurIPS 2023（Neural Information Processing Systems）神经信息处理系统大会于近日公布论文录用结果，根据官网邮件显示，本届会议共有12343篇有效论文投稿，接收率为 26.1％，高于 2022 年的 25.6％...',
      date: '2023年10月9日',
      year: 2023,
      month: 10,
      url: 'OPEN_NEWS_43',
      img: require('../img/newscenter/news43.png')
    },
    {
      id: 41,
      title: '腾讯参与制定Vulkan矩阵扩展标准，推动机器学习加速计算发展',
      content: '随着人工智能技术的发展，机器学习应用场景越来越广泛，从智能语音助手到自动驾驶，从智能推荐到图像识别，都需要大量的计算资源来支持。而GPU作为一种高效的计算资源，越来越受到关注，成为机器学习加速计算的重要工具。然而，跨硬件通用加速缺乏...',
      date: '2023年8月18日',
      year: 2023,
      month: 8,
      url: 'OPEN_NEWS_41',
      img: require('../img/newscenter/news41.png')
    },
    {
      id: 40,
      title: 'IJCAI 2023 | 腾讯优图实验室入选论文解读，含小样本学习方法、玻璃物体分割、RSI变化检测研究方向',
      content: '近日，IJCAI 2023（International Joint Conference on Artificial Intelligence）国际人工智能联合大会公布了录用结果。本届会议共有4566篇投稿，接收率为15%。作为当前全球...',
      date: '2023年7月18日',
      year: 2023,
      month: 7,
      url: 'OPEN_NEWS_40',
      img: require('../img/newscenter/news40.png')
    },
    {
      id: 33,
      title: '腾讯优图实验室2项计算机视觉行业标准获工信部立项，助力建设AI标准体系',
      content: '工信部印发《2022年第三批行业标准制修订和外文版项目计划》，腾讯优图实验室2项计算机视觉领域行业标准被列入计划，分别为《人工智能-深度合成图像系统技术规范》、《人工智能-智能字符识别...',
      date: '2023年3月18日',
      year: 2023,
      month: 3,
      url: 'OPEN_NEWS_33',
      img: require('../img/newscenter/news33.png')
    },
    {
      id: 31,
      title: 'CVPR 2023 | 腾讯优图实验室21篇论文入选，含多模态、工业异常检测、动态表情识别、活体检测等领域',
      content: '计算机视觉三大顶级会议之一CVPR 2023 论文接收结果出炉！近年来，CVPR投稿数量正持续增加，今年更是收到有效投稿9155篇，创下历史新高！最终，大会收录论文2360篇，接收率为 25.78 %。...',
      date: '2023年3月15日',
      year: 2023,
      month: 3,
      url: 'OPEN_NEWS_31',
      img: require('../img/newscenter/news31.png')
    },
    {
      id: 32,
      title: '喜报！腾讯云智能获选国家工信部工业互联网APP优秀解决方案',
      content: '近日，“工业质检APP解决方案”成功入选工信部发布《2022年工业互联网APP优秀解决方案名单》，作为腾讯优图实验室精心打磨而出的软硬一体AI外观质检解决方案，工业质检APP解决方案服务了众多...',
      date: '2023年2月14日',
      year: 2023,
      month: 2,
      url: 'OPEN_NEWS_32',
      img: require('../img/newscenter/news32.jpeg')
    },
    {
      id: 27,
      title: 'AAAI 2023 | 腾讯优图实验室16篇论文入选，含多标签分类、姿态估计、目标检测、HOI、小样本学习等研究方向',
      content: '近日，AAAI 2023（Association for the Advancement of Artificial Intelligence）国际先进人工智能协会公布了录用结果，本届会议共有8777篇投稿，录用1721篇，录用率19.6%。...',
      date: '2022年11月28日',
      year: 2022,
      month: 11,
      url: 'OPEN_NEWS_27',
      img: require('../img/newscenter/news27.png')
    },
    {
      id: 24,
      title: 'NeurIPS 2022 | 腾讯优图实验室8篇论文入选，含单次通讯联邦学习、无监督异常检测、视频文本检索等研究方向',
      content: '近日，NeurIPS 2022（Neural Information Processing Systems）神经信息处理系统大会公布了录用结果。根据官网邮件中给出的数据，本届会议共有10411篇投稿，接收率为25.6%。...',
      date: '2022年9月27日',
      year: 2022,
      month: 9,
      url: 'OPEN_NEWS_24',
      img: require('../img/newscenter/news24.png')
    },
    {
      id: 20,
      title: 'ICML 2022 | 腾讯优图实验室入选论文解读，含联邦学习、自监督模型研究方向',
      content: '近日，腾讯优图实验室2篇论文被机器学习国际顶级会议 ICML（International Conference on Machine Learning，国际机器学习大会）所接收，涵盖联邦学习、自监督模型研究...',
      date: '2022年8月12日',
      year: 2022,
      month: 8,
      url: 'OPEN_NEWS_20',
      img: require('../img/newscenter/news20.png')
    },
    {
      id: 12,
      title: '掌纹识别的“免费午餐”，腾讯优图推出掌纹生成预训练方法',
      content: '掌纹识别作为一种新型生物特征识别方式，在疫情下无接触身份识别、用户使用意愿方面展现出较大优势...',
      date: '2022年7月20日',
      year: 2022,
      month: 7,
      url: 'OPEN_NEWS_12',
      img: require('../img/newscenter/news12.png')
    },
    {
      id: 18,
      title: 'ECCV 2022 | 腾讯优图29篇论文入选，含人脸安全、图像分割、目标检测等多个研究方向',
      content: '近日，欧洲计算机视觉国际会议ECCV 2022（European Conference on Computer Vision）发布了论文录用结果。本届ECCV 2022论文总投稿数超过8170篇，其中1629篇论文中选...',
      date: '2022年7月12日',
      year: 2022,
      month: 7,
      url: 'OPEN_NEWS_18',
      img: require('../img/newscenter/news18.png')
    },
    {
      id: 11,
      title: 'ncnn发布20220420版本，让Vulkan神经网络推理得更快',
      content: 'ncnn是腾讯开源的手机端极致优化的高性能神经网络前向计算框架。Vulkan是一个低开销、跨平台的3D图形与计算的API标准。相较于基于cuda/cudnn的GPU加速方案，Vulkan具有更好的兼容性和可移植性...',
      date: '2022年5月16日',
      year: 2022,
      month: 5,
      url: 'OPEN_NEWS_11',
      img: require('../img/newscenter/news11.jpg')
    },
    {
      id: 3,
      title: '腾讯优图TFace发布新版本，新增人脸安全模块',
      content: 'TFace是由腾讯优图实验室研发的可信人脸算法研究项目，重点关注人脸识别、人脸安全、人脸质量等技术领域，通过开源自研的方法，方便研究人员快速复现我们的工作。自开源以来，本项目在业界获得了广泛关注...',
      date: '2022年3月11日',
      year: 2022,
      month: 3,
      url: 'OPEN_NEWS_3',
      img: require('../img/newscenter/news3.jpg')
    }
    /* {
      id: 7,
      title: '一场培训引发的“灵魂拷问” ',
      content: '腾讯云AI智能培训机器人：是基于语音识别（ASR）、语音合成（TTS）、自然语言理解模型（NLP）与深度学习等AI技术打造的人机对练一体化智能培训平台，通过完善的智能学习机制，帮助企业快速打造智能、高效、便捷、低成本的企业学堂...',
      date: '2022年3月9日',
      year: 2022,
      month: 3,
      url: 'OPEN_NEWS_7',
      img: require('../img/newscenter/news7.jpg')
    } */
  ],
  REPORT: [
    {
      id: 67,
      title: '腾讯联合上海交通大学发布大模型时代的AI十大趋势：走进“机器外脑”时代',
      content: '人工智能迅速发展，大模型技术成为赋能各行各业的关键。从算力底座、智力增强到人机协作，大模型正在重塑人类社会，成为可依赖的"外脑"。...',
      date: '2024年7月9日',
      year: 2024,
      month: 7,
      url: 'OPEN_NEWS_67',
      img: require('../img/newscenter/news67.png')
    },
    {
      id: 66,
      title: '腾讯发布：影响2024年的十大科技应用趋势｜2万字全文',
      content: '过去一年，我们见证了数字科技的加速度。每个人都身处变革巨浪之中，既对大模型的突破进展无比兴奋，也对未来充满了无限憧憬。...',
      date: '2024年1月25日',
      year: 2024,
      month: 1,
      url: 'OPEN_NEWS_66',
      img: require('../img/newscenter/news66.png')
    },
    {
      id: 38,
      title: '干货分享 | 《人机共生——大模型时代的AI十大趋势报告》',
      content: '7月7日，世界人工智能大会期间，《人机共生——大模型时代的AI十大趋势报告》发布。...',
      date: '2023年7月7日',
      year: 2023,
      month: 7,
      url: 'OPEN_NEWS_38',
      img: require('../img/newscenter/news38.jpeg')
    },
    {
      id: 65,
      title: '重磅报告 | 智创互联·2023金融科技十大趋势（附下载）',
      content: '近期，国家印发《数字中国建设整体布局规划》，提出建设数字中国是推进中国式现代化的重要引擎，要求强化数字中国的关键能力。党的二十大报告提出，“加快发展数字经济，促进数字经济和实体经济深度融合”，标志着未来金融科技将迈入高质量发展的新阶段。...',
      date: '2023年5月23日',
      year: 2023,
      month: 5,
      url: 'OPEN_NEWS_65',
      img: require('../img/newscenter/news65.png')
    },
    {
      id: 64,
      title: '重磅发布：全真互联·银行数字化发展研究报告｜附报告下载',
      content: '2月4日，在2022深圳国际金融科技节“金融数字化与业务安全分论坛”上，腾讯研究院联合腾讯云、腾讯优图实验室、中国银联、光大银行、北京银行、长沙银行，重磅发布《全真互联·银行数字化发展研究报告》。报告首提“全真银行”，全景呈现了在数实融合的趋势下，银行在打破线上线下的边界，推进数字化、全真化过程中的探索路径和前沿洞察。...',
      date: '2023年2月6日',
      year: 2023,
      month: 2,
      url: 'OPEN_NEWS_64',
      img: require('../img/newscenter/news64.png')
    },
    {
      id: 35,
      title: '重磅报告 | 智创互联·2023金融科技十大趋势',
      content: '近期，国家印发《数字中国建设整体布局规划》，提出建设数字中国是推进中国式现代化的重要引擎，要求强化数字中国的关键能力。党的二十大报告提出，“加快发展数字经济...',
      date: '2023年5月23日',
      year: 2023,
      month: 5,
      url: 'OPEN_NEWS_35',
      img: require('../img/newscenter/news35.png')
    },
    {
      id: 30,
      title: '重磅发布：全真互联·银行数字化发展研究报告｜附报告下载',
      content: '2月4日，在2022深圳国际金融科技节“金融数字化与业务安全分论坛”上，腾讯研究院联合腾讯云、腾讯优图实验室、中国银联、光大银行、北京银行、长沙银行，重磅发布《全真互联·银行数字化发展研究报告》。报告首提“全真银行”，全景呈现了在数实融合的趋势下，银行在打破线上线下的边界，推进数字化、全真化过程中的探索路径和前沿洞察。...',
      date: '2023年2月6日',
      year: 2023,
      month: 2,
      url: 'OPEN_NEWS_30',
      img: require('../img/newscenter/news30.png')
    },
    {
      id: 6,
      title: '腾讯优图实验室联合厦门大学首次发布《2021十大人工智能趋势》',
      content: '近日，2021全球人工智能技术大会在杭州成功举办，在计算机视觉论坛上，腾讯优图实验室副总经理黄飞跃正式宣布，腾讯优图联合厦门大学人工智能研究院正式发布《2021十大人工智能趋势》（以下简称趋势报告），该趋势报告基于腾讯优图和厦门大学人工智能研究院...',
      date: '2021年6月7日',
      year: 2021,
      month: 6,
      url: 'OPEN_NEWS_6',
      img: require('../img/newscenter/news6.jpg')
    }
  ]
};



// WEBPACK FOOTER //
// ./src/components/open/panels/news/data/newscenter.js